import type React from "react";

// dev_lp — menu configuration.
// All links are intentionally INERT (dead links) for now. `route` documents the
// intended destination so wiring real navigation later is a one-line change per item.
// `kind: "scroll"` items will smooth-scroll to an in-page anchor once those sections exist.

export interface DevMenuItem {
  i18nKey: string; // key under the "menu" namespace
  route: string; // intended future destination (not active yet)
  kind: "link" | "scroll";
  anchor?: string; // for scroll items (e.g. contact section id)
}

export const DEV_MENU_ITEMS: DevMenuItem[] = [
  { i18nKey: "articles", route: "/articles", kind: "link" },
  { i18nKey: "about", route: "/about", kind: "link" },
  { i18nKey: "terms", route: "/terms-and-privacy", kind: "link" },
  { i18nKey: "accessibility", route: "/accessibility-statement", kind: "link" },
  { i18nKey: "contact", route: "#contact-section", kind: "scroll", anchor: "contact-section" },
  { i18nKey: "register", route: "/enduser/auth", kind: "link" },
  { i18nKey: "login", route: "/enduser/auth", kind: "link" },
];

// Auth items rendered as prominent buttons (register / login) — also inert for now.
export const DEV_AUTH_ITEMS: DevMenuItem[] = [
  { i18nKey: "register", route: "/enduser/auth", kind: "link" },
  { i18nKey: "login", route: "/enduser/auth", kind: "link" },
];

// no-op handler for dead links (keeps anchors keyboard-accessible without navigating)
export const deadLinkHandler = (e: React.MouseEvent) => {
  e.preventDefault();
};
